import React from 'react'
import { AreaTools, AreaSelection } from 'models/editor'
import { Icon } from 'components/Icon'

export const getIcon = (tool: AreaSelection) => {
  switch (tool) {
    case AreaTools.POINT:
      return <Icon name="map-pin-line" />
    case AreaTools.POINT_PONDERA:
      return <Icon name="coins-line" />
    case AreaTools.POLYGON:
      return <Icon name="shape-fill" />
    case AreaTools.RADIUS:
      return <Icon name="compass-2-line" />
    case AreaTools.TRAFFIC_TOOL:
      return <Icon name="traffic-light-line" />
    case AreaTools.MOBILITY_REPORT_TOOL:
      return <Icon name="base-station-line" />
    case AreaTools.PREDICTIVE_REPORT_TOOL:
      return <Icon name="focus-2-line" />
    case AreaTools.CUSTOM_REPORT_TOOL:
      return <Icon name="markup-line" />
    case AreaTools.KEYWORDS_REPORT_TOOL:
      return <Icon name="file-chart-line" />
  }
}
